export default {
  name: 'PublicCarousel',
  props: {
    items: { type: Array, default: () => [] },
    itemKey: { type: [String, Function], default: 'id' },
    compact: { type: Boolean, default: false },
    itemWidth: { type: String, default: '' },
    label: { type: String, required: true },
    previousLabel: { type: String, required: true },
    nextLabel: { type: String, required: true },
  },
  data() { return { overflowing: false }; },
  computed: {
    carouselStyle() {
      const visible = Math.max(1, Math.min(this.items.length + (this.$slots.after ? 1 : 0), 5));
      return {
        '--carousel-item-width': this.itemWidth || (this.compact
          ? `minmax(196px, min(300px, calc((100% - ${(visible - 1) * 14}px) / ${visible})))`
          : 'minmax(250px, 1fr)'),
      };
    },
  },
  mounted() {
    this.updateOverflow();
    window.addEventListener('resize', this.updateOverflow);
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this.$refs.scroller);
    }
  },
  updated() { this.updateOverflow(); },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateOverflow);
    this.resizeObserver?.disconnect();
  },
  methods: {
    keyFor(item, index) { return (typeof this.itemKey === 'function' ? this.itemKey(item, index) : item?.[this.itemKey]) ?? index; },
    updateOverflow() {
      const scroller = this.$refs.scroller;
      this.overflowing = Boolean(scroller && scroller.scrollWidth > scroller.clientWidth + 1);
    },
    scroll(direction) {
      const scroller = this.$refs.scroller;
      scroller?.scrollBy({ left: direction * Math.round(scroller.clientWidth * 0.72), behavior: 'smooth' });
    },
  },
};
